import { useLocalStorage } from '@/src/hooks/useLocalStorage';
import { useAppStore } from '@/src/store/global/index';
import { isNullOrBlank } from '@/src/lib/MayzSmartDB';
import { useEffect, useState } from 'react';

export const useModalWelcomeMessage = () => {
    //--------------------------------------
    const [isRefreshing, setIsRefreshing] = useState(true);
    useEffect(() => {
        setIsRefreshing(false);
    }, []);
    //--------------------------------------
    const appStore = useAppStore();
    const [userConfirmedMessage, setUserConfirmedMessage] = useLocalStorage('userConfirmedMessage', 0);
    //--------------------------------------
    const [isOpen, setIsOpen] = useState(false);
    //--------------------------------------
    const handleOpen = () => {
        setIsOpen(true);
    };
    const handleClose = () => {
        setUserConfirmedMessage(appStore.siteSettings!.welcomeMessageIndex);
        setIsOpen(false);
    };
    //--------------------------------------
    useEffect(() => {
        if (appStore.isAppStoreLoaded && appStore.siteSettings !== undefined) {
            if (!isNullOrBlank(appStore.siteSettings.welcomeMessage) && userConfirmedMessage !== appStore.siteSettings.welcomeMessageIndex) {
                setIsOpen(true);
            }
        }
    }, [appStore.isAppStoreLoaded]);
    //--------------------------------------
    return {
        isRefreshing,
        appStore,
        isOpen,
        handleOpen,
        handleClose,
    };
    //--------------------------------------
};
